export default __webpack_public_path__ + "static/media/needImg2.ac64a286.png";